import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '../Icon'
import { IconButton } from '../Button'
import './nav.css'

export interface RailDestination { id: string; to: string; label: string; icon: string; active: boolean }

/**
 * Collapsed rail M3 (96px): bottone menu, FAB (slot M3), al massimo 5 destinazioni (le stesse della navigation bar
 * piu' quella del gruppo attivo). Il resto della navigazione, l'account e "Esci" stanno nel menu completo
 * (modal expanded rail) che si apre dal bottone in testa. Se l'altezza non basta le destinazioni scorrono:
 * nessuna voce viene tagliata.
 */
export function NavigationRail({
  destinations, menuIcon, menuLabel, onMenu, fabSlot,
}: {
  destinations: RailDestination[]
  menuIcon: string
  menuLabel: string
  onMenu: () => void
  /** FAB (azioni rapide) nello slot FAB del rail, sotto il bottone menu. */
  fabSlot?: ReactNode | undefined
}) {
  return (
    <nav className="md-rail" aria-label="Menu principale">
      <IconButton icon={menuIcon} aria-label={menuLabel} onClick={onMenu} className="md-rail__menu" />
      {fabSlot}
      <div className="md-rail__dests">
        {destinations.map(d => (
          <Link key={d.id} to={d.to} className="md-rail__dest md-state" data-active={d.active}
            aria-current={d.active ? 'page' : undefined} aria-label={d.label}>
            <span className="md-rail__indicator"><Icon name={d.icon} size={24} filled={d.active} /></span>
            <span className="md-rail__label">{d.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  )
}
